 import React from "react";
import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";
import "./AirEffect.css";

import healthImg from "../../assets/healthimg.jpg";
import plantsImg from "../../assets/plantimg.jpg";
import acidImg from "../../assets/acidimg.jpg";
import wildfireImg from "../../assets/wildlifeimg.jpg";

const AirEffects = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <div className="effects-page">
        <section className="effects-hero">
          <div className="hero-content">
            <span>Climate Change</span>
            <h1>
              Effects of Air Pollution
              on Health & Environment
            </h1>
            <p>
              Air pollution is one of the biggest environmental
              challenges affecting human health, wildlife,
              forests, climate, and ecosystems worldwide.
            </p>
          </div>
        </section>

        <section className="effect-section">
          <div className="effect-image">
            <img src={healthImg} alt="Health Effects" />
          </div>
          <div className="effect-content">
            <span>Human Health</span>
            <h2>How Air Pollution Affects Human Health</h2>
            <p>
              Air pollution directly damages the human respiratory
              and cardiovascular systems. Polluted air contains
              dangerous gases and tiny particles that enter the lungs
              and bloodstream.
            </p>
            <p>
              Short-term exposure can cause coughing,
              throat irritation, headaches, dizziness,
              asthma attacks, and breathing difficulties.
            </p>
            <p>
              Long-term exposure increases the risk of
              lung diseases, strokes, heart attacks,
              weakened immunity, and lung cancer.
            </p>
            <h3>Solutions</h3>
            <ul>
              <li>Reduce vehicle emissions by using public transport.</li>
              <li>Promote clean and renewable energy.</li>
              <li>Use air quality monitoring systems.</li>
              <li>Plant more trees in urban areas.</li>
            </ul>
          </div>
        </section>

        <section className="effect-section reverse">
          <div className="effect-image">
            <img src={plantsImg} alt="Plants Damage" />
          </div>
          <div className="effect-content">
            <span>Environment</span>
            <h2>Damage to Plants & Wildlife</h2>
            <p>
              Air pollution weakens forests,
              damages crops, and harms biodiversity.
              Toxic gases reduce plant growth
              and destroy leaves.
            </p>
            <p>
              Wildlife habitats are also affected.
              Animals suffer from respiratory diseases,
              ecosystem imbalance, and water contamination.
            </p>
            <p>
              Ozone pollution especially damages crops,
              forests, and natural ecosystems.
            </p>
            <h3>Solutions</h3>
            <ul>
              <li>Reduce industrial smoke emissions.</li>
              <li>Protect forests and green spaces.</li>
              <li>Promote eco-friendly farming methods.</li>
              <li>Support wildlife conservation programs.</li>
            </ul>
          </div>
        </section>

        <section className="effect-section">
          <div className="effect-image">
            <img src={acidImg} alt="Acid Rain" />
          </div>
          <div className="effect-content">
            <span>Environmental Damage</span>
            <h2>Acid Rain & Ecosystem Destruction</h2>
            <p>
              Acid rain forms when sulfur dioxide (SO₂)
              and nitrogen oxides (NOₓ)
              react with water vapor in the atmosphere.
            </p>
            <p>
              Acid rain damages rivers, lakes,
              forests, buildings, and soil fertility.
              It also destroys aquatic ecosystems.
            </p>
            <p>
              Historical monuments and infrastructure
              are slowly weakened by acidic chemicals.
            </p>
            <h3>Solutions</h3>
            <ul>
              <li>Use low-sulfur fuels.</li>
              <li>Install filters in factories.</li>
              <li>Reduce fossil fuel burning.</li>
              <li>Switch to renewable energy sources.</li>
            </ul>
          </div>
        </section>

        <section className="effect-section reverse">
          <div className="effect-image">
            <img src={wildfireImg} alt="Climate Change" />
          </div>
          <div className="effect-content">
            <span>Climate Crisis</span>
            <h2>Climate Change & Wildfires</h2>
            <p>
              Greenhouse gases released from pollution
              trap heat in the atmosphere,
              causing global warming and climate change.
            </p>
            <p>
              Rising global temperatures lead to
              melting glaciers, heatwaves,
              droughts, floods, and severe wildfires.
            </p>
            <p>
              Wildfire smoke releases harmful particles
              that worsen air quality
              and threaten nearby communities.
            </p>
            <h3>Solutions</h3>
            <ul>
              <li>Reduce global carbon emissions.</li>
              <li>Increase renewable energy usage.</li>
              <li>Prevent deforestation.</li>
              <li>Support sustainable lifestyles.</li>
            </ul>
          </div>
        </section>

        <section className="table-section">
          <span>Health Impacts</span>
          <h2>Effects of Air Pollution on Humans</h2>
          <table>
            <thead>
              <tr>
                <th>Short-Term Effects</th>
                <th>Long-Term Effects</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Coughing</td>
                <td>Lung Disease</td>
              </tr>
              <tr>
                <td>Headaches</td>
                <td>Heart Problems</td>
              </tr>
              <tr>
                <td>Eye Irritation</td>
                <td>Lung Cancer</td>
              </tr>
              <tr>
                <td>Difficulty Breathing</td>
                <td>Premature Death</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="prevention-section">
          <span>Act Now</span>
          <h2>How We Can Reduce Air Pollution</h2>
          <div className="prevention-grid">
            <div className="prevention-card">
              <h3>Clean Energy</h3>
              <p>
                Solar and wind energy help reduce
                greenhouse gas emissions.
              </p>
            </div>
            <div className="prevention-card">
              <h3>Plant More Trees</h3>
              <p>
                Trees absorb carbon dioxide
                and improve air quality naturally.
              </p>
            </div>
            <div className="prevention-card">
              <h3>Reduce Vehicle Use</h3>
              <p>
                Public transport and cycling
                reduce harmful emissions.
              </p>
            </div>
            <div className="prevention-card">
              <h3>Save Electricity</h3>
              <p>
                Lower energy use means
                less fossil fuel burning.
              </p>
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="stat-card">
            <h1>7M+</h1>
            <p>Deaths yearly due to air pollution</p>
          </div>
          <div className="stat-card">
            <h1>99%</h1>
            <p>People breathe polluted air globally</p>
          </div>
          <div className="stat-card">
            <h1>4.2M</h1>
            <p>Deaths caused by outdoor pollution yearly</p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default AirEffects;